import { SET_BEHAVIOR } from './constants';

export const setModalBehavior = ({ name, isVisible }) => ({
  type: SET_BEHAVIOR,
  payload: {
    name,
    isVisible,
  },
});
